module.exports = __webpack_public_path__ + "img/main_title.852f67a5.png";